import mixin from './spinner-mixin.js';

export default {
  name: 'SpinnerMtech',
  mixins: [mixin],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      attrs: {
        width: this.size,
        height: this.size,
        viewBox: '-10 -10 44 44',
        preserveAspectRatio: 'xMidYMid',
        xmlns: 'http://www.w3.org/2000/svg',
      },
    }, [
      h('g', {
        attrs: {
          transform: 'translate(0, 12) rotate (22, 12, 12)',
        },
      }, [
        h('path', {
          attrs: {
            // eslint-disable-next-line max-len
            d: 'M20.869,13.476C20.948,12.994,21,12.504,21,12    s-0.052-0.994-0.131-1.476l-2.463-0.259c-0.149-0.556-0.367-1.082-0.648-1.57l1.558-1.924c-0.576-0.806-1.281-1.511-2.087-2.087    l-1.924,1.558c-0.488-0.281-1.015-0.499-1.57-0.648l-0.259-2.463C12.994,3.052,12.504,3,12,3s-0.994,0.052-1.476,0.131    l-0.259,2.463C9.71,5.743,9.184,5.961,8.695,6.242L6.771,4.685C5.966,5.261,5.261,5.966,4.685,6.771l1.558,1.924    c-0.281,0.488-0.499,1.015-0.648,1.57l-2.463,0.259C3.052,11.006,3,11.496,3,12s0.052,0.994,0.131,1.476l2.463,0.259    c0.149,0.556,0.367,1.082,0.648,1.57l-1.558,1.924c0.576,0.806,1.281,1.511,2.087,2.087l1.924-1.558    c0.488,0.281,1.015,0.499,1.57,0.648l0.259,2.463C11.006,20.948,11.496,21,12,21s0.994-0.052,1.476-0.131l0.259-2.463    c0.556-0.149,1.082-0.367,1.57-0.648l1.924,1.558c0.806-0.576,1.511-1.281,2.087-2.087l-1.558-1.924    c0.281-0.488,0.499-1.015,0.648-1.57L20.869,13.476z M12,15.998c-2.209,0-3.998-1.789-3.998-3.998S9.791,8.002,12,8.002    S15.998,9.791,15.998,12S14.209,15.998,12,15.998z',
            fill: '#EA1A1A',
          },
        }, [
          h('animateTransform', {
            attrs: {
              attributeName: 'transform',
              type: 'rotate',
              from: '0 12 12',
              to: '90 12 12',
              dur: '1s',
              repeatCount: 'indefinite',
            },
          }),
        ]),
      ]),
      h('g', {
        attrs: {
          transform: 'translate(0, -12) rotate (22, 12, 12)',
        },
      }, [
        h('path', {
          attrs: {
            // eslint-disable-next-line max-len
            d: 'M20.869,13.476C20.948,12.994,21,12.504,21,12    s-0.052-0.994-0.131-1.476l-2.463-0.259c-0.149-0.556-0.367-1.082-0.648-1.57l1.558-1.924c-0.576-0.806-1.281-1.511-2.087-2.087    l-1.924,1.558c-0.488-0.281-1.015-0.499-1.57-0.648l-0.259-2.463C12.994,3.052,12.504,3,12,3s-0.994,0.052-1.476,0.131    l-0.259,2.463C9.71,5.743,9.184,5.961,8.695,6.242L6.771,4.685C5.966,5.261,5.261,5.966,4.685,6.771l1.558,1.924    c-0.281,0.488-0.499,1.015-0.648,1.57l-2.463,0.259C3.052,11.006,3,11.496,3,12s0.052,0.994,0.131,1.476l2.463,0.259    c0.149,0.556,0.367,1.082,0.648,1.57l-1.558,1.924c0.576,0.806,1.281,1.511,2.087,2.087l1.924-1.558    c0.488,0.281,1.015,0.499,1.57,0.648l0.259,2.463C11.006,20.948,11.496,21,12,21s0.994-0.052,1.476-0.131l0.259-2.463    c0.556-0.149,1.082-0.367,1.57-0.648l1.924,1.558c0.806-0.576,1.511-1.281,2.087-2.087l-1.558-1.924    c0.281-0.488,0.499-1.015,0.648-1.57L20.869,13.476z M12,15.998c-2.209,0-3.998-1.789-3.998-3.998S9.791,8.002,12,8.002    S15.998,9.791,15.998,12S14.209,15.998,12,15.998z',
            fill: '#EA1A1A',
          },
        }, [
          h('animateTransform', {
            attrs: {
              attributeName: 'transform',
              type: 'rotate',
              from: '0 12 12',
              to: '90 12 12',
              dur: '1s',
              repeatCount: 'indefinite',
            },
          }),
        ]),
      ]),
      h('g', {
        attrs: {
          transform: 'translate(-12, 0)',
        },
      }, [
        h('path', {
          attrs: {
            // eslint-disable-next-line max-len
            d: 'M20.869,13.476C20.948,12.994,21,12.504,21,12    s-0.052-0.994-0.131-1.476l-2.463-0.259c-0.149-0.556-0.367-1.082-0.648-1.57l1.558-1.924c-0.576-0.806-1.281-1.511-2.087-2.087    l-1.924,1.558c-0.488-0.281-1.015-0.499-1.57-0.648l-0.259-2.463C12.994,3.052,12.504,3,12,3s-0.994,0.052-1.476,0.131    l-0.259,2.463C9.71,5.743,9.184,5.961,8.695,6.242L6.771,4.685C5.966,5.261,5.261,5.966,4.685,6.771l1.558,1.924    c-0.281,0.488-0.499,1.015-0.648,1.57l-2.463,0.259C3.052,11.006,3,11.496,3,12s0.052,0.994,0.131,1.476l2.463,0.259    c0.149,0.556,0.367,1.082,0.648,1.57l-1.558,1.924c0.576,0.806,1.281,1.511,2.087,2.087l1.924-1.558    c0.488,0.281,1.015,0.499,1.57,0.648l0.259,2.463C11.006,20.948,11.496,21,12,21s0.994-0.052,1.476-0.131l0.259-2.463    c0.556-0.149,1.082-0.367,1.57-0.648l1.924,1.558c0.806-0.576,1.511-1.281,2.087-2.087l-1.558-1.924    c0.281-0.488,0.499-1.015,0.648-1.57L20.869,13.476z M12,15.998c-2.209,0-3.998-1.789-3.998-3.998S9.791,8.002,12,8.002    S15.998,9.791,15.998,12S14.209,15.998,12,15.998z',
            fill: '#1919EA',
          },
        }, [
          h('animateTransform', {
            attrs: {
              attributeName: 'transform',
              type: 'rotate',
              from: '90 12 12',
              to: '0 12 12',
              dur: '1s',
              repeatCount: 'indefinite',
            },
          }),
        ]),
      ]),
      h('g', {
        attrs: {
          transform: 'translate(12, 0)',
        },
      }, [
        h('path', {
          attrs: {
            // eslint-disable-next-line max-len
            d: 'M20.869,13.476C20.948,12.994,21,12.504,21,12    s-0.052-0.994-0.131-1.476l-2.463-0.259c-0.149-0.556-0.367-1.082-0.648-1.57l1.558-1.924c-0.576-0.806-1.281-1.511-2.087-2.087    l-1.924,1.558c-0.488-0.281-1.015-0.499-1.57-0.648l-0.259-2.463C12.994,3.052,12.504,3,12,3s-0.994,0.052-1.476,0.131    l-0.259,2.463C9.71,5.743,9.184,5.961,8.695,6.242L6.771,4.685C5.966,5.261,5.261,5.966,4.685,6.771l1.558,1.924    c-0.281,0.488-0.499,1.015-0.648,1.57l-2.463,0.259C3.052,11.006,3,11.496,3,12s0.052,0.994,0.131,1.476l2.463,0.259    c0.149,0.556,0.367,1.082,0.648,1.57l-1.558,1.924c0.576,0.806,1.281,1.511,2.087,2.087l1.924-1.558    c0.488,0.281,1.015,0.499,1.57,0.648l0.259,2.463C11.006,20.948,11.496,21,12,21s0.994-0.052,1.476-0.131l0.259-2.463    c0.556-0.149,1.082-0.367,1.57-0.648l1.924,1.558c0.806-0.576,1.511-1.281,2.087-2.087l-1.558-1.924    c0.281-0.488,0.499-1.015,0.648-1.57L20.869,13.476z M12,15.998c-2.209,0-3.998-1.789-3.998-3.998S9.791,8.002,12,8.002    S15.998,9.791,15.998,12S14.209,15.998,12,15.998z',
            fill: '#1919EA',
          },
        }, [
          h('animateTransform', {
            attrs: {
              attributeName: 'transform',
              type: 'rotate',
              from: '90 12 12',
              to: '0 12 12',
              dur: '1s',
              repeatCount: 'indefinite',
            },
          }),
        ]),
      ]),
    ]);
  },
};



// WEBPACK FOOTER //
// ./src/components/spinner-mtech.js